














import Vue from "vue";

// Model
import { MaintenanceStatusEnum, MaintenanceStatusEnumToLabel, GetMachineMaintenanceStatusIconColor } from "@/model/data/status/MaintenanceStatusEnum";

// Vue components
import LocaleDateTimeTooltip from "@/components/LocaleDateTimeTooltip.vue";

export default Vue.extend({
    components: {
        LocaleDateTimeTooltip,
    },
    computed: {
        label() {
            return this.$t(MaintenanceStatusEnumToLabel(this.status));
        },
        showNextMaintenanceDate() {
            return this.status == MaintenanceStatusEnum.CloseToMaintenance;
        },
    },
    props: ["status", "nextMaintenance"],
    methods: {
        getIconColor(status: MaintenanceStatusEnum) {
            return GetMachineMaintenanceStatusIconColor(status);
        },
    },
});
